import React, { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { toast } from "react-toastify";
import { X } from "lucide-react";

import SelectField from "../ui/SelectField";

const ModalAsignarSuscripcion = ({ open, onClose, empresa, onUpdated }) => {
  const [planes, setPlanes] = useState([]);
  const [seleccion, setSeleccion] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const API = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    const cargarPlanes = async () => {
      try {
        const res = await fetch(`${API}/admin/suscripciones`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const data = await res.json();
        if (!res.ok) throw new Error(data.message);
        setPlanes(data);
      } catch {
        toast.error("Error al cargar los planes");
      }
    };

    if (open) cargarPlanes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const guardar = async () => {
    if (!seleccion) {
      toast.warning("Seleccione un plan para continuar");
      return;
    }

    try {
      setIsLoading(true);
      const res = await fetch(
        `${API}/admin/empresas/${empresa._id}/suscripcion`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ suscripcionId: seleccion }),
        },
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.message);

      toast.success("Plan actualizado correctamente ✔️");
      onUpdated();
      onClose();
    } catch {
      toast.error("Error al asignar suscripción");
    } finally {
      setIsLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-lg overflow-hidden">
        {/* Header */}
        <div className="relative px-6 py-4 border-b">
          <h2 className="text-xl font-semibold text-gray-800">
            Asignar Suscripción
          </h2>
          <button
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
            onClick={onClose}
          >
            <X />
          </button>
        </div>

        {/* Scroll interno */}
        <div className="flex-1 overflow-y-auto">
          <div className="p-10 space-y-8">
            {/* Empresa */}
            <p className="text-gray-700">
              <span className="font-semibold">Empresa:</span>{" "}
              {empresa?.razon_social}
            </p>

            {/* Plan */}
            <SelectField
              label="Plan de suscripción"
              name="plan"
              value={seleccion}
              options={planes}
              onChange={(e) => setSeleccion(e.target.value)}
              displayFn={(p) =>
                `${p.nombre} — ${p.maxUsuarios} usuarios / ${p.maxEquipos} equipos`
              }
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-2 p-6 border-t">
          <Button variant="outline" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            onClick={guardar}
            className="bg-blue-600 text-white hover:bg-blue-700"
            disabled={isLoading}
          >
            {isLoading ? "Guardando..." : "Guardar"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ModalAsignarSuscripcion;
